/* ============================================================
   Engelszahlen-Monetarisierung
   Aktivierung: GrowthBook-Flag "ez-monetization" (Experiment) oder ?ezm=on|off.
   1. Produkt-Strip unter dem Rechner (sofort)
   2. Result-CTA: beobachtet das Rechner-Ergebnis (#engelszahl) und zeigt die
      passenden Produkte zur berechneten Zahl (korrekte Zuordnung via Handle).
   ATC -> Theme-Slide-Cart (bewährtes Muster). Exposure nur auf diesen Pages.
   ============================================================ */
(function () {
  'use strict';

  function ready(cb) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb);
    else cb();
  }

  ready(function () {
    var root = document.querySelector('[data-ezm]');
    if (!root || root.dataset.ezmInit === '1') return;
    root.dataset.ezmInit = '1';

    var moneyFormat = root.getAttribute('data-money-format') || '€{{amount}}';
    function formatMoney(cents) {
      var d = (cents / 100).toFixed(2).replace('.', ',');
      return moneyFormat.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/g, d).replace(/<[^>]*>/g, '').trim() || ('€' + d);
    }

    var products = [];
    try { products = JSON.parse(root.querySelector('[data-ezm-data]').textContent); } catch (e) {}
    function productFor(num, type) {
      var h = 'angel-number-' + String(num).repeat(3) + '-' + type;
      return products.find(function (p) { return p.handle === h; }) || null;
    }

    // ---------- Aktivierung: URL > GrowthBook ----------
    var activated = false;
    function activate() {
      if (activated) return;
      activated = true;
      document.documentElement.setAttribute('data-ezm-on', '1');
      mount();
    }
    var u = (new URLSearchParams(location.search).get('ezm') || '').toLowerCase();
    if (['on', '1', 'true'].indexOf(u) > -1) { activate(); }
    else if (['off', '0', 'false'].indexOf(u) > -1) { /* Control erzwingen */ }
    else {
      var tries = 0;
      (function poll() {
        var gb = window._growthbook || window.growthbook || window.gb;
        if (gb && gb.ready && typeof gb.getFeatureValue === 'function') {
          if (gb.getFeatureValue('ez-monetization', null) === true) activate();
          return;
        }
        if (tries++ < 30) setTimeout(poll, 100);
      })();
    }

    // ---------- Karten ----------
    function card(p, compact) {
      var label = p.available ? (compact ? '+ Warenkorb' : 'In den Warenkorb') : 'Ausverkauft';
      var el = document.createElement('div');
      el.className = 'ezm-card';
      el.innerHTML =
        '<a href="' + p.url + '"><img src="' + p.img + '" alt="" loading="lazy" width="200" height="200"></a>' +
        '<a class="ezm-card__title" href="' + p.url + '">' + p.title.replace('Engelszahl ', '').replace(' Angel Number', '') + '</a>' +
        '<span class="ezm-card__price">' + (p.compare > p.price ? '<span class="ezm-card__compare">' + formatMoney(p.compare) + '</span>' : '') + formatMoney(p.price) + '</span>' +
        '<button type="button" class="ezm-card__atc"' + (p.available ? '' : ' disabled') + '>' + label + '</button>';
      var btn = el.querySelector('.ezm-card__atc');
      if (p.available) btn.addEventListener('click', function () { addToCart(p.variantId, btn); });
      return el;
    }

    function addToCart(variantId, btn) {
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        body: 'id=' + variantId + '&quantity=1'
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          btn.disabled = false;
          if (item && item.status && item.status !== 200) { btn.textContent = 'Nicht verfügbar'; return; }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
          } catch (e) {}
          var trigger = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
          if (trigger) trigger.click();
        })
        .catch(function () { btn.disabled = false; });
    }

    // ---------- Montage ----------
    function mount() {
      // 1. Strip mit allen Produkten füllen + unter dem Rechner platzieren
      var stripCards = root.querySelector('[data-ezm-strip-cards]');
      products
        .slice()
        .sort(function (a, b) { return a.handle.localeCompare(b.handle); })
        .forEach(function (p) { stripCards.appendChild(card(p)); });

      var strip = root.querySelector('[data-ezm-strip]');
      // Robuster Anker: direkt nach dem Ergebnis-Container (= unterm Rechner-Tool).
      // Fallback-Kette für die Guide-Page / abweichendes Markup.
      var resultAnchor = document.getElementById('result');
      var form = document.getElementById('engelszahlenForm');
      var anchor = resultAnchor || (form ? form.parentElement : null) || document.querySelector('.page-content .rte');
      if (anchor) anchor.insertAdjacentElement('afterend', strip);
      else root.appendChild(strip);
      root.hidden = false;
      root.style.display = 'block';
      strip.style.display = 'block';

      // 2. Result-Hook: auf das Rechner-Ergebnis warten
      var numEl = document.getElementById('engelszahl');
      var resultEl = document.getElementById('result');
      var resBlock = root.querySelector('[data-ezm-result]');
      if (!numEl || !resultEl || !resBlock) return;

      var shown = false;
      function maybeShow() {
        var m = (numEl.textContent || '').match(/(\d)\1\1/);
        if (!m) return;
        var num = parseInt(m[1], 10);
        var cards = resBlock.querySelector('[data-ezm-result-cards]');
        cards.innerHTML = '';
        var a = productFor(num, 'armband');
        var h = productFor(num, 'halskette');
        if (!a && !h) return;
        if (a) cards.appendChild(card(a, true));
        if (h) cards.appendChild(card(h, true));
        resBlock.querySelector('[data-ezm-num]').textContent = String(num).repeat(3);
        var num2 = resBlock.querySelector('[data-ezm-num2]');
        if (num2) num2.textContent = String(num).repeat(3);
        resultEl.appendChild(resBlock);
        resBlock.style.display = 'block';
        // Das Original-JS crasht bei manchen Zahlen (Buy-Button-SDK mit invaliden IDs)
        // BEVOR es #result einblendet -> Anzeige hier erzwingen (fixt den Rechner in der Variante).
        var spin = document.getElementById('spinner');
        if (spin) spin.style.display = 'none';
        resultEl.style.display = 'block';
        shown = true;
      }
      new MutationObserver(function () { maybeShow(); }).observe(numEl, { childList: true, characterData: true, subtree: true });
      maybeShow(); // falls Ergebnis schon da

      // 3. Copy-Chip
      var chip = root.querySelector('[data-ezm-copy]');
      if (chip) chip.addEventListener('click', function () {
        var code = chip.getAttribute('data-ezm-copy');
        function done() {
          var t = chip.childNodes[0];
          var orig = t.textContent;
          t.textContent = 'Kopiert ✓';
          setTimeout(function () { t.textContent = orig; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done);
        else done();
      });
    }
  });
})();
